import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { PrintJsonMessage } from 'app/services/socket.service';

export type ModalSocketErrorsProcessType = 'Upload' | 'QC' | 'UploadWithQC';
export interface SocketErrorsModalData {
	processType: ModalSocketErrorsProcessType;
	messages: {
		upload?: PrintJsonMessage[];
		qc?: PrintJsonMessage[]
	};
}

@Component({
	selector: 'app-socket-errors-modal',
	templateUrl: './socket-errors-modal.component.html',
	styleUrls: ['./socket-errors-modal.component.css']
})
export class SocketErrorsModalComponent implements OnInit {

	public processType: ModalSocketErrorsProcessType;
	public errors: any[];
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: SocketErrorsModalData,
		public dialogRef: MatDialogRef<SocketErrorsModalComponent>
	) { }

	ngOnInit() {
		this.processType = this.data.processType;
		if (this.data.messages) {
			const uploadMessages = this.data.messages.upload || [];
			const qcMessages = this.data.messages.qc || [];
			this.errors = uploadMessages.concat(qcMessages);
		}
	}

}
